import './App.css';
import Header from "./components/layouts/Header";
import Footer from "./components/layouts/Footer";
import Hero from "./components/Hero";
import Actions from "./components/Actions";
import About from "./components/About";
import Contact from "./components/Contact";
import { ScrollToTop } from "./components/inc/BackTop";


import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

function App() {
  return (
    <div className="App ">
      <Header/>
      <Hero/>
      <Actions/>
      <About/>
      <Contact/>
      <ScrollToTop/>
      <Footer/>
    </div>
  );
}

export default App;
